module.exports = __webpack_public_path__ + "media/img/logo-agency-7aaaec6caaf088195c22c061d6710a64.svg";